import {ReactSVG} from 'react-svg';

export const getIcon = (key) => {
    switch (key) {
        case "address":
            return <ReactSVG src="assets/icons/svg/address.svg"/>
        case "clock":
            return <ReactSVG src="assets/icons/svg/clock.svg"/>
        case "phone":
            return <ReactSVG src="assets/icons/svg/phone.svg"/>
        case "mail":
            return <ReactSVG src="assets/icons/svg/mail.svg"/>
        case "prev":
            return <ReactSVG src="assets/icons/svg/prev.svg"/>
        case "next":
            return <ReactSVG src="assets/icons/svg/next.svg"/>
        case "calendar":
            return <ReactSVG src="assets/icons/svg/calendar.svg"/>
        case "drop-down":
            return <ReactSVG src="assets/icons/svg/drop-down.svg"/>
        case "person":
            return <ReactSVG src="assets/icons/svg/person.svg"/>
        case "separator":
            return <ReactSVG src="assets/icons/svg/separator.svg"/>
        case "close":
            return <ReactSVG src="assets/icons/svg/close.svg"/>
        default:
            return;

    }
}
export const getLogo = (type = 1) => {
    switch (type) {
        case 1:
        default:
            return <img src={"/assets/logo/logo.png"} alt=""/>
        case 2:
            return <img src={"/assets/logo/logo-word.png"} alt=""/>
    }
    // return <ReactSVG src="assets/logo/logo.svg"/>

}
/**
 * Cuộn mượt đến phần tử có ID được chỉ định.
 * @param {string} id - ID của phần tử HTML cần cuộn đến.
 * @param {ScrollLogicalPosition} [block='start'] - Căn chỉnh dọc ('start', 'center', 'end', 'nearest'). Mặc định là 'start'.
 * @param {ScrollLogicalPosition} [inline='nearest'] - Căn chỉnh ngang ('start', 'center', 'end', 'nearest'). Mặc định là 'nearest'.
 */
export const smoothScrollToId = (id, block = 'start', inline = 'nearest') => {
    console.log(`Attempting to scroll to element with ID: ${id}`); // Thêm log để debug
    const element = document.getElementById(id);

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth', // Yếu tố chính để cuộn mượt
            block: block,       // Căn chỉnh theo chiều dọc
            inline: inline,     // Căn chỉnh theo chiều ngang
        });
        console.log(`Successfully found and scrolled to element:`, element); // Log thành công
    } else {
        console.warn(`Element with ID "${id}" not found. Cannot scroll.`); // Cảnh báo nếu không tìm thấy
    }
};